module.exports = __webpack_public_path__ + "static/media/girl-11.fdcf47c3.svg";